<template>
  <div class="app-header header-shadow bg-onlaine-waves" style="z-index: 13">

    <div class="app-header__logo">
      <div class="header__pane ml-auto">
        <div>

          <!--               :class="{'active':menuFixed}"-->
          <svg class="hamburg-menu active"
               width="26"
               height="26"
               viewBox="0 0 32 42"

               xmlns="http://www.w3.org/2000/svg"
               @click="back()"
          >
            <g transform="matrix(1,0,0,1,-389.5,-264.004)">
              <g id="arrow_left2">
                <g transform="matrix(1,0,0,1,0,5)">
                  <path
                      id="hamburg-top"
                      d="M390,270L420,270L420,270C420,270 420.195,250.19 405,265C389.805,279.81 390,279.967 390,279.967"
                  />
                </g>
                <g
                    transform="matrix(1,1.22465e-16,1.22465e-16,-1,0.00024296,564.935)"
                >
                  <path
                      id="hamburg-bottom"
                      d="M390,270L420,270L420,270C420,270 420.195,250.19 405,265C389.805,279.81 390,279.967 390,279.967"
                  />
                </g>
                <path id="middle" d="M390,284.967L420,284.967"/>
              </g>
            </g>
          </svg>


        </div>
      </div>
      <router-link class="logo-not-fixed" style="z-index: 1" :to="{name:'dashboard'}">
        <div class="logo-src" :class="{'menu-hover':menuHover}" @click="checkLink('dashboard')"></div>
      </router-link>

    </div>
    <div class="app-header__mobile-menu">
      <div>
        <button type="button" class="hamburger hamburger--elastic mobile-toggle-nav"
                :class="{'is-active':openMenuMobile}" @click="toggleMobileMenu()">
                    <span class="hamburger-box">
                        <span class="hamburger-inner"></span>
                    </span>
        </button>
      </div>
    </div>
    <div class="app-header__menu">

      <t-app-menu-right-button-mobile :user="user"/>

    </div>

    <!--add class header-mobile-open-->
    <div class="app-header__content">

      <div class="app-header-left">
        <ul class="header-megamenu nav" v-if="fastInsert && fastInsert.length > 0" @mouseover="showMenu"
            @mouseleave="hideMenu">
          <li class="nav-item">
            <a data-placement="bottom" rel="popover-focus" data-offset="300" data-toggle="popover-custom"
               class="nav-link" data-original-title="" title="">
              <i class="nav-link-icon pe-7s-note"> </i>
              Adicionar
              <i class="fa fa-angle-down ml-2 opacity-5"></i>
            </a>
            <div class="rm-max-width">
              <div class="popover fade bs-popover-bottom show" :class="{'display-none':!menuInsertShow}" role="tooltip"
                   id="popover299759"
                   style="position: absolute; transform: translate3d(274px, 49px, 0px); top: -12px; left: -300px; will-change: transform;"
                   x-placement="bottom">
                <div class="arrow" style="left: 135px;"></div>
                <h3 class="popover-header"></h3>
                <div class="popover-body">
                  <div class="dropdown-mega-menu" style="width: 15rem">
                    <div class="grid-menu grid-menu-1col">
                      <div class="no-gutters row">
                        <!--                        <div class="col-sm-6 col-xl-4">
                                                  <ul class="nav flex-column">
                                                    <li class="nav-item-header nav-item">
                                                      Vendas
                                                    </li>
                                                    <li class="nav-item">
                                                      <b-link class="nav-link" @click="disabledLink()"><span>Orçamento</span></b-link>
                                                    </li>
                                                    <li class="nav-item">
                                                      <b-link class="nav-link" @click="disabledLink()"><span>Pedido</span></b-link>
                                                    </li>
                                                    <li class="nav-item">
                                                      <b-link class="nav-link" @click="disabledLink()"><span>Nota Fiscal</span></b-link>
                                                    </li>
                                                  </ul>
                                                </div>-->
                        <div class="col-sm-12 col-xl-12" style="border-right-width:0px"
                             v-if="columnArch.length > 0">
                          <ul class="nav flex-column">
                            <li class="nav-item-header nav-item">
                              Cadastro Rápido
                            </li>

                            <li class="nav-item" v-for="item in columnArch" :key="item.pageId">
                              <b-link class="nav-link" @click="hideMenu()" :to="{name:item.link}">
                                <span>{{ item.title }}</span></b-link>
                            </li>

                          </ul>
                        </div>
                        <div class="col-sm-12 col-xl-12" style="border-right-width:0px"
                             v-if="columnProduction.length > 0">
                          <ul class="nav flex-column">
                            <li class="nav-item-header nav-item">
                              Produção
                            </li>

                            <li class="nav-item" v-for="item in columnProduction" :key="item.pageId">
                              <b-link class="nav-link" @click="hideMenu()" :to="{name:item.link}">
                                <span>{{ item.title }}</span></b-link>
                            </li>

                          </ul>
                        </div>
                        <!--                        <div class="col-sm-6 col-xl-6">
                                                  <ul class="nav flex-column">
                                                    <li class="nav-item-header nav-item">Financeiro</li>
                                                    <li class="nav-item">
                                                      <b-link class="nav-link" @click="disabledLink()"><span>Pedido de Compra</span></b-link>
                                                    </li>
                                                    <li class="nav-item">
                                                      <b-link class="nav-link" @click="disabledLink()"><span>Despesa</span></b-link>
                                                    </li>
                                                    <li class="nav-item">
                                                      <b-link class="nav-link" @click="disabledLink()"><span>Receita</span></b-link>
                                                    </li>
                                                  </ul>
                                                </div>-->
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </li>
        </ul>
      </div>

      <div class="app-header-right">
        <t-app-header-search-button/>
        <t-app-notification/>

        <t-app-user :user="user"/>

        <t-app-menu-right-button v-if="false"/>

      </div>
    </div>

  </div>
</template>

<script>

import tAppHeaderSearchButton from "@/components/template/header/t-app-header-search-button";
import tAppNotification from "@/components/template/header/t-app-notification";
import tAppUser from "@/components/template/header/t-app-user";
import tAppMenuRightButton from "@/components/template/menu-right/t-app-menu-right-button";
import tAppMenuRightButtonMobile from "@/components/template/menu-right/t-app-menu-right-button-mobile";
import ui from "@/assets/scripts/ui";

export default {
  name: "t-app-header",
  components: {tAppHeaderSearchButton, tAppNotification, tAppUser, tAppMenuRightButton, tAppMenuRightButtonMobile},
  data() {
    return {
      menuInsertShow: false,
      columnArch: [],
      columnSale: [],
      columnProduction: [],
      columnFinance: [],
    }
  },
  props: {
    fastInsert: {
      type: Array,
      required: true,
    },
    user: {
      type: Object,
      required: true,
    },
  },
  mounted() {

    /*Define aqui as colunas na ordem desejada*/
    for (let item of this.fastInsert) {

      if (item.column === 'production') {
        this.columnProduction.push(item)
      } else if (item.column === 'sale') {
        this.columnSale.push(item)
      } else if (item.column === 'finance') {
        this.columnFinance.push(item)
      }else if (item.column === 'arch') {
        this.columnArch.push(item)
      }

    }

  },
  methods: {

    toggleMobileMenu() {
      const old = this.openMenuMobile
      this.$store.commit("setOpenMenuMobile", !old)
    },

    checkLink(name) {

      if (name === this.$route.name) {
        this.$emit("pageRefresh")
      }

    },

    showMenu() {
      this.menuInsertShow = true
    },
    hideMenu() {
      this.menuInsertShow = false
    },
    back() {
      this.$router.back()
    },
    disabledLink() {
      ui.msgError(this, "Desculpe página indisponível para este tipo de demonstração");
    },

  },
  computed: {
    openMenuMobile() {
      return this.$store.getters.getOpenMenuMobile
    },

    menuFixed() {
      return this.$store.getters.getMenuFixedOld && this.$store.getters.getMenuFixed;
    },
    menuHover() {
      return this.$store.getters.getMenuHover
    }
  },

}
</script>

<style scoped>
.hamburg-menu {
  fill-rule: evenodd;
  clip-rule: evenodd;
  stroke-linecap: round;
  stroke-linejoin: round;
  stroke-miterlimit: 1.5;
  cursor: pointer;

}

.hamburg-menu path {
  fill: none;
  stroke: #000000;;
  stroke-width: 1px;
}


#hamburg-top,
#hamburg-bottom {
  stroke-dasharray: 30, 75.39;
  transition: all 0.6s cubic-bezier(0.6, 0.33, 0.67, 1.29);
}

.hamburg-menu.active #hamburg-top,
.hamburg-menu.active #hamburg-bottom {
  stroke-dasharray: 75.39;
  stroke-dashoffset: -60;
}

.hamburg-menu:nth-child(2) {
  transform: rotate(0deg);
  transition: transform 0.6s cubic-bezier(0.165, 0.84, 0.44, 1);
}

.hamburg-menu:nth-child(2) path {
  transition: all 0.4s ease-in-out 0.6s;
}

.hamburg-menu:nth-child(2).active {
  transform: rotate(180deg);
}

.bg-onlaine-waves {
  background: url("https://static.onlaine.com.br/images/curvas-op50.png") no-repeat 400px -40px #FFFFFF;
  background-size: 556px;
}

.bg-onlaine-waves:before {

}

.logo-src {
  background-position-y: 10px !important;
  background-size: 80% !important;
  background-repeat: no-repeat !important;
  background-position: center left !important;
}
</style>
